import { useCallback, useContext } from 'react';

import Analytics from '@hh.ru/analytics-js';
import responseVideoCallInviteButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/responses/resume_card/response_videocall_invite_button_click';
import { Card, Text } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import InviteToVideoCallModal from 'src/components/InviteToVideoCall';
import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import translation from 'src/components/translation';
import { useOnOffState } from 'src/hooks/useOnOffState';

const TrlKeys = {
    text: 'resume.online.interview.invite',
};

const InviteToVideoCall: TranslatedComponent<{ closeMenu: () => void }> = ({ closeMenu, trls }) => {
    const { isResponse, lastEmployerStateExtName, resume, resumeStateUpdate, vacancyId } =
        useContext(ResumeCardActionsContext);
    const topicId = resume.topicId;

    const sendAnalytics = useCallback(() => {
        responseVideoCallInviteButtonClick({ topicId, vacancyId, folderName: lastEmployerStateExtName || 'unknown' });
        !isResponse && Analytics.sendHHEventButtonClick('video_call_search_open');
    }, [isResponse, lastEmployerStateExtName, topicId, vacancyId]);

    const [isInviteFromVisible, openInviteFrom, closeInviteFrom] = useOnOffState(false);

    const handleClick = useCallback(() => {
        sendAnalytics();
        openInviteFrom();
    }, [openInviteFrom, sendAnalytics]);

    return (
        <>
            <Card
                onClick={handleClick}
                borderRadius={16}
                padding={12}
                paddingLeft={16}
                hoverStyle="secondary"
                stretched
                data-qa="online-interview-trigger"
            >
                <Text style="primary" typography="label-2-regular">
                    {trls[TrlKeys.text]}
                </Text>
            </Card>
            {isInviteFromVisible && (
                <InviteToVideoCallModal
                    onClose={() => {
                        closeInviteFrom();
                        closeMenu();
                    }}
                    applicant={{
                        name: resume.firstName?.[0]?.string || '',
                        lastName: resume.lastName?.[0]?.string || '',
                        resumeHash: resume._attributes.hash,
                    }}
                    topicId={topicId}
                    resumeStateUpdate={resumeStateUpdate}
                />
            )}
        </>
    );
};

export default translation(InviteToVideoCall);
